/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ProjectFundingReferenceExternalIdentifierDTO
 */
export interface ProjectFundingReferenceExternalIdentifierDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectFundingReferenceExternalIdentifierDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectFundingReferenceExternalIdentifierDTO
     */
    identifier?: string;
}

/**
 * Check if a given object implements the ProjectFundingReferenceExternalIdentifierDTO interface.
 */
export function instanceOfProjectFundingReferenceExternalIdentifierDTO(value: object): value is ProjectFundingReferenceExternalIdentifierDTO {
    return true;
}

export function ProjectFundingReferenceExternalIdentifierDTOFromJSON(json: any): ProjectFundingReferenceExternalIdentifierDTO {
    return ProjectFundingReferenceExternalIdentifierDTOFromJSONTyped(json, false);
}

export function ProjectFundingReferenceExternalIdentifierDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectFundingReferenceExternalIdentifierDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'identifier': json['identifier'] == null ? undefined : json['identifier'],
    };
}

export function ProjectFundingReferenceExternalIdentifierDTOToJSON(json: any): ProjectFundingReferenceExternalIdentifierDTO {
    return ProjectFundingReferenceExternalIdentifierDTOToJSONTyped(json, false);
}

export function ProjectFundingReferenceExternalIdentifierDTOToJSONTyped(value?: ProjectFundingReferenceExternalIdentifierDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'identifier': value['identifier'],
    };
}


